export default __webpack_public_path__ + "images/logoCodex.3541ca5b8c2e54ac194b3b9ac142c586.svg"